// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { pollingPDFMerge } = require('actions/mergePreContractualsPDF');

// @ constants
const actionTypes = require('constants/actionTypes');

// @ actions
import { sendGPData } from './migration';

const contractualPollingInitRequest = () => ({
  type: actionTypes.CONTRACTUAL_POLLING_INIT_REQUEST,
});

const contractualPollingInitSuccess = operationProcessId => ({
  type: actionTypes.CONTRACTUAL_POLLING_INIT_SUCCESS,
  payload: {
    operationProcessId,
  },
});

const contractualPollingInitFailure = () => ({
  type: actionTypes.CONTRACTUAL_POLLING_INIT_FAILURE,
});

const contractualPollingDocumentsRequest = () => ({
  type: actionTypes.CONTRACTUAL_POLLING_DOCUMENTS_REQUEST,
});

const contractualPollingDocumentsSuccess = () => ({
  type: actionTypes.CONTRACTUAL_POLLING_DOCUMENTS_SUCCESS,
});

const contractualPollingDocumentsFailure = () => ({
  type: actionTypes.CONTRACTUAL_POLLING_DOCUMENTS_FAILURE,
});

const getContractualPollingDocuments =
  (counterLoop = 0) =>
  (dispatch, getState) => {
    dispatch(contractualPollingDocumentsRequest());
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    return APIGet(
      dispatch,
      apiURLBuilder.getURL('precontractualPollingDocuments', { operationProcessId })
    )
      .then(response => {
        const { operationProcessStatus } = response;
        if (operationProcessStatus === 'ERROR') {
          dispatch(contractualPollingDocumentsFailure());
        } else if (operationProcessStatus === 'PENDING') {
          if (counterLoop > 15) {
            dispatch(contractualPollingDocumentsFailure());
          } else {
            setTimeout(() => dispatch(getContractualPollingDocuments(counterLoop + 1)), 2000);
          }
        } else if (['DOCUMENTS_COMPLETED', 'COMPLETED'].includes(operationProcessStatus)) {
          dispatch(contractualPollingDocumentsSuccess());
          dispatch(pollingPDFMerge(operationProcessId));
        }
      })
      .catch(() => dispatch(contractualPollingDocumentsFailure()));
  };

const migrationContractualPollingInitialization = (
  dispatch,
  gpData,
  handleSuccess,
  handleError
) => {
  dispatch(contractualPollingInitRequest());
  return sendGPData(dispatch, gpData)
    .then(response => {
      handleSuccess(response.operationProcessId);
      dispatch(contractualPollingInitSuccess(response.operationProcessId));
      dispatch(getContractualPollingDocuments());
    })
    .catch(error => {
      handleError(error);
      dispatch(contractualPollingInitFailure());
    });
};

module.exports = {
  migrationContractualPollingInitialization,
};
